import createPersistedState from 'vuex-persistedstate';
import { useStorage } from './storage';
import { createStore } from 'vuex';
import DbModule from './modules/db.js';
import DbPlugin from './plugins/db.js';
import SettingsModule from './modules/settings.js';
import SettingsPlugin from './plugins/settings.js';
import ThemeModule from './modules/theme.js';
import ThemePlugin from './plugins/theme.js';
import LayoutModule from './modules/layout.js';
import FeatureAccessModule from './modules/feature-access.js';
// import PersistencePlugin from './plugins/persistence.js';

let storage = useStorage();

// storage.initDB();
// console.log('storage, initDB');

// storage.clear();
// console.log('storage, clearDB');

// 共用 storage adapter，一次取得唯一 storage 實例
const storageAdapter = (() => {
	console.log('storage-adapter, init');
	if (!storage) {
		storage = useStorage(); // 單次呼叫，取得同一個 singleton
	}
	return {
		getItem: key => storage.get(key),
		setItem: (key, value) => storage.set(key, value),
		removeItem: key => storage.remove(key),
	};
})();

// 工廠函式，簡化 createPersistedState 建立
const persistState = (key, paths) =>
	createPersistedState({
		key,
		storage: storageAdapter,
		paths,
	});

// eslint-disable-next-line no-undef
// const debug = YSS_ENV !== 'production';
const debug = true;

// Vuex Store
const store = createStore({
	strict: debug,
	modules: {
		db: DbModule,
		settings: SettingsModule,
		theme: ThemeModule,
		layout: LayoutModule,
		featureAccess: FeatureAccessModule,
	},
	plugins: [
		persistState('YouEvent365_asm_organizer.db', ['db']),
		persistState('YouEvent365_asm_organizer.settings', ['settings']),
		persistState('YouEvent365_asm_organizer.theme', ['theme']),
		DbPlugin,
		SettingsPlugin,
		ThemePlugin,
	],
});

export default store;
